const Panning: React.FC<any> = ({ size, ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg"{...props} width={size || '20'} height={size || '20'} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5.2 9l-3 3 3 3M9 5.2l3-3 3 3M15 18.9l-3 3-3-3M18.9 9l3 3-3 3M3.3 12h17.4M12 3.2v17.6" />
  </svg>
);

export default Panning;
